import { IConfigsType } from '../../types'

const primantiConfig: IConfigsType = {
  primanti: {
    '/:brand/systemwide_overview': {
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: ['week', 'period', 'quarter', 'year', 'last_week', 'this_week'],
      },
      systemwideOverview: {
        type: 'list',
        api: 'systemwideOverviewKpis',
        title: 'Systemwide Overview',
        fieldWidth: '150px',
        fields: [
          {
            content: {
              key: 'netSales',
            },
            bottom: 'Total Sales',
          },
          {
            content: {
              key: 'netSalesSssPercent',
              decimal: 1,
            },
            bottom: 'SSS %',
          },
          {
            content: {
              key: 'checkCount',
            },
            bottom: 'Check Count',
          },
          {
            content: {
              key: 'checkCountVsLyPercent',
              decimal: 1,
            },
            bottom: 'Check Count % vs LY',
          },
          {
            content: {
              key: 'checkAverage',
              decimal: 2,
            },
            bottom: 'Check Average',
          },
          {
            content: {
              key: 'hourlyLaborCostPercent',
              decimal: 1,
            },
            bottom: 'Hourly Labor Percent',
          },
        ],
      },
      breakdownByStore: {
        type: 'table',
        api: 'systemwideOverview',
        title: 'Breakdown by Store',
        pageSize: 20,
        defaultSortedField: 'netSales',
        groupInfo: {
          width: '200px',
          groupBy: {
            width: '200px',
          },
        },
        columns: [
          {
            key: 'Net Sales',
            title: 'Net Sales',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'netSales',
                title: '$',
                align: 'center',
                sortable: true,
              },
              {
                key: 'netSalesSssPercent',
                title: 'YOY%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
            ],
          },
          {
            key: 'Hourly Labor',
            title: 'Hourly Labor',
            align: 'center',
            children: [
              {
                key: 'hourlyLaborCostPercent',
                title: '%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
            ],
          },
        ],
      },
      map: {
        type: 'map',
        api: 'listGeoInfo',
      },
    },
  },
}

export default primantiConfig
